import { useEffect, useState } from "react";
import { PrimaryInput } from "common";

import * as S from "./styled";

export const AutocompleteInput = ({ register, value, children, ...rest }) => {
  const [selectOpen, setSelectOpen] = useState(false);
  const [focused, setFocused] = useState(false);

  const onBlur = () => setTimeout(() => setFocused(false), 200);

  const onFocus = () => setFocused(true);

  useEffect(() => {
    if (focused && value?.trim()) {
      setSelectOpen(true);
    } else {
      setSelectOpen(false);
    }
  }, [focused, value]);

  useEffect(() => {
    if (value?.trim()) {
      setFocused(true);
      setSelectOpen(true);
    } else {
      setSelectOpen(false);
    }
  }, [value]);

  return (
    <S.Container>
      <PrimaryInput register={register} onBlur={onBlur} onFocus={onFocus} {...rest} />
      {selectOpen && <S.Box className="pac-container">{children}</S.Box>}
    </S.Container>
  );
};
